import assert from "assert"

import type mongoose from "mongoose"

import { ensureMongooseConnection } from "./ensureMongooseConnection"
import { getTenantIdFromLoadModelCtx, type LoadModelCtx } from "./modelsApi"


const getAppName = (): string => {
  const appName = process.env.APP_NAME?.trim()
  assert(appName, "Missing APP_NAME")
  return appName
}

const normalizeTenantId = (tenantId: string): string => {
  const normalized = tenantId.trim()
  assert(normalized, "Tenant ID is missing")
  return normalized
}

export const getTenantFilesystemDbName = (tenantId: string): string =>
  `${getAppName()}-${normalizeTenantId(tenantId)}-filesystem-db`

export const getTenantFilesystemDb = async (tenantId: string): Promise<mongoose.Connection> =>
  ensureMongooseConnection(getTenantFilesystemDbName(tenantId))

export const getTenantFilesystemDbFromCtx = async (ctx: LoadModelCtx): Promise<mongoose.Connection> => {
  const tenantId = getTenantIdFromLoadModelCtx(ctx)
  return getTenantFilesystemDb(tenantId)
}
